export enum PaymentPlatformEnum {
	STRIPE = 'STRIPE',
	PAWAPAY = 'PAWAPAY',
	FEDAPAY = 'FEDAPAY',
	HUB2 = 'HUB2',
	PAYPAL = 'PAYPAL',
	MYCOOLPAY = 'MYCOOLPAY',
	APPLE_IAP = 'APPLE_IAP',
	GOOGLE_IAP = 'GOOGLE_IAP',
	CAMPAY = 'CAMPAY',
	WAVE = 'WAVE',
	FEEXPAY = 'FEEXPAY',
	NEXUS = 'NEXUS',
}
